// Input states for the search flow
export const INPUT_STATE = {
    FILTER: 'filter', // Selecting a filter/field
    OPERATOR: 'operator', // Selecting an operator
    VALUE: 'value', // Entering a value
    FREE_TEXT: 'free_text', // Free text search (no filter selected)
};

// Null operator symbols
export const NULL_OPERATOR = 'Ø';
export const NOT_NULL_OPERATOR = '!Ø';

// Helper to check if an operator is a null operator (no value required)
export const isNullOperator = (operator) => operator === NULL_OPERATOR || operator === NOT_NULL_OPERATOR;

// GraphQL has two types: number and string. Two operator sets (single-value only; no multiselect or range).

/** Operators for number type: =, !=, >, <, >=, <=, is empty, is not empty. */
export const NUMBER_OPERATORS = [
    { symbol: '=', label: 'Equals', icon: 'equal' },
    { symbol: '!=', label: 'Not equals', icon: 'not-equal-variant' },
    { symbol: '>', label: 'Greater than', icon: 'greater-than' },
    { symbol: '<', label: 'Less than', icon: 'less-than' },
    { symbol: '>=', label: 'Greater or equal', icon: 'greater-than-or-equal' },
    { symbol: '<=', label: 'Less or equal', icon: 'less-than-or-equal' },
    { symbol: NULL_OPERATOR, label: 'Is empty', icon: 'null' },
    { symbol: NOT_NULL_OPERATOR, label: 'Is not empty', icon: 'not-equal-variant' },
];

/** Operators for string type: =, !=, contains, like, starts/ends with, etc. No greater/less than. */
export const STRING_OPERATORS = [
    { symbol: '=', label: 'Equals', icon: 'equal' },
    { symbol: '!=', label: 'Not equals', icon: 'not-equal-variant' },
    { symbol: '~', label: 'Contains', icon: 'contain' },
    { symbol: '!~', label: 'Does not contain', icon: 'contain-end' },
    { symbol: 'contains', label: 'Contains - case insensitive', icon: 'contain' },
    { symbol: 'not contains', label: 'Does not contain - case insensitive', icon: 'contain-end' },
    { symbol: 'like', label: 'Like - case sensitive', icon: 'format-text' },
    { symbol: 'not like', label: 'Not like - case sensitive', icon: 'format-text' },
    { symbol: 'ilike', label: 'Like - case insensitive', icon: 'format-text' },
    { symbol: 'not ilike', label: 'Not like - case insensitive', icon: 'format-text' },
    { symbol: 'starts with', label: 'Starts with - case insensitive', icon: 'arrow-expand-right' },
    { symbol: 'not starts with', label: 'Does not start with - case insensitive', icon: 'arrow-collapse-right' },
    { symbol: 'ends with', label: 'Ends with - case insensitive', icon: 'arrow-expand-left' },
    { symbol: 'not ends with', label: 'Does not end with - case insensitive', icon: 'arrow-collapse-left' },
    { symbol: NULL_OPERATOR, label: 'Is empty', icon: 'null' },
    { symbol: NOT_NULL_OPERATOR, label: 'Is not empty', icon: 'not-equal-variant' },
];

// Operators that appear in both NUMBER_OPERATORS and STRING_OPERATORS; used to build OPERATORS without duplicates
const NUMBER_OPERATOR_SYMBOLS = new Set(NUMBER_OPERATORS.map((op) => op.symbol));

/** All operators (for filters that do not specify a type). */
export const OPERATORS = [
    ...NUMBER_OPERATORS,
    ...STRING_OPERATORS.filter((op) => !NUMBER_OPERATOR_SYMBOLS.has(op.symbol)),
];

